import { css, useTheme } from "@emotion/react";
import { rem, transparentize } from "polished";
import React from "react";

import { Flex, Label, Spacer } from "../../base";

const renderIconComponent = (icon, props = {}) => {
  let iconComponent;
  if (typeof icon === "string") {
    iconComponent = <img alt="" src={icon} {...props} />;
  } else if (typeof icon === "function") {
    iconComponent = icon(props);
  } else if (typeof icon === "object") {
    iconComponent = icon;
  }

  return iconComponent;
};

interface NotificationProps {
  title: string;
  subtitle?: string;
  icon?: any;
  RightIcon?: any;
}

const Notification = ({
  title,
  subtitle,
  icon,
  RightIcon,
  ...props
}: NotificationProps) => {
  const { color } = useTheme();

  return (
    <Flex
      start
      borderRadius={24}
      css={css`
        width: auto;
        position: relative;
        right: 0;
        min-width: ${rem(360)};

        padding: ${rem(24)};

        box-shadow: 0px ${rem(4)} ${rem(24)}
          ${transparentize(0.75, color.highlight)};

        background: #fff;
        margin-bottom: ${rem(12)};
      `}
      {...props}
    >
      {renderIconComponent(icon, {
        css: css`
          width: ${rem(42)};
          height: ${rem(42)};
        `,
      })}

      <Spacer col size={20} />
      <div>
        <Label small>{title}</Label>
        <Spacer size={8} />
        <Label light small color="lighter">
          {subtitle}
        </Label>
      </div>
      <Spacer col size={48} />
      {RightIcon ? (
        <RightIcon
          css={css`
            height: ${rem(28)};
          `}
          fill={color.highlight}
        />
      ) : null}
    </Flex>
  );
};

export default Notification;
